@if (elements()) {
  @for (element of elements(); track element) {
    <gea-shop-wagtail-element [element]="element"></gea-shop-wagtail-element>
  }
}